/* eslint-disable react/prop-types */
import React, { useState } from "react";
// Common
import FadeIn from "../common/FadeIn";
//Packages
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
//Auth
import { isAuthenticatedTutor } from "./services/TutorAuth.js"; //import auth
//Icon Library
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
//Loading
import LoadingSpinner from "../LoadingSpinner";


const OverviewPage = (props) => {
  const classes = props.classes;
  // Manage State
  const [filterDay, setFilterDay] = useState(
    JSON.parse(window.sessionStorage.getItem("filterDay"))
  );
  const [filterVenue, setFilterVenue] = useState(
    JSON.parse(window.sessionStorage.getItem("filterVenue"))
  );
  const [filterLessonType, setFilterLessonType] = useState(
    JSON.parse(window.sessionStorage.getItem("filterLessonType"))
  );
  const [filterAvailableClasses, setFilterAvailableClasses] = useState(
    JSON.parse(window.sessionStorage.getItem("filterAvailableClasses"))
  );

  //Create Array of Unique LessonTypes
  const LessonTypes = [...new Set(classes.map((q) => q.LessonType))].sort();
  //Create Array of Unique Venues
  const Venues = [...new Set(classes.map((v) => v.Venue.VenueName))].sort();
  // Variables
  let filteredClasses;
  let classesToFilter;
  //Filter first first for available classes only (those classes with free spaces)
  const availableClasses = classes.filter((e) => {
    return e.Subscribers_Number < e.MaxLearners;
  });
  //Filter Classes for if "available classes" is selected.
  if (filterAvailableClasses === "true") {
    classesToFilter = availableClasses;
  } else {
    classesToFilter = classes;
  }
  // Conditional Logic for Filters
  //no filters
  if (!filterDay && !filterVenue && !filterLessonType) {
    filteredClasses = classesToFilter;
  }
  //filter day only
  else if (filterDay && !filterVenue && !filterLessonType) {
    filteredClasses = classesToFilter.filter((t) => {
      return t.Day === filterDay;
    });
  }
  //filter venue only
  else if (!filterDay && filterVenue && !filterLessonType) {
    filteredClasses = classesToFilter.filter((t) => {
      return t.Venue.VenueName === filterVenue;
    });
  }

  //filter LessonType only
  else if (!filterDay && !filterVenue && filterLessonType) {
    filteredClasses = classesToFilter.filter((t) => {
      return t.LessonType === filterLessonType;
    });
  }

  //filter venue & day but not LessonType
  else if (filterDay && filterVenue && !filterLessonType) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Venue.VenueName === filterVenue) & (t.Day === filterDay);
    });
  }

  //filter venue & LessonType but not Day
  else if (!filterDay && filterVenue && filterLessonType) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Venue.VenueName === filterVenue) & (t.LessonType === filterLessonType);
    });
  }

  //filter Day & LessonType but not venue
  else if (filterDay && !filterVenue && filterLessonType) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Day === filterDay) & (t.LessonType === filterLessonType);
    });
  }

  //filter Day & LessonType & venue
  else if (filterDay && filterVenue && filterLessonType) {
    filteredClasses = classesToFilter.filter((t) => {
      return (
        (t.Day === filterDay) &
        (t.LessonType === filterLessonType) &
        (t.Venue.VenueName === filterVenue)
      );
    });
  }

  return (
    <div className='OverviewClassViewer'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticatedTutor() ? (
          <div>
            {classes.length !== 0 ? (
              <Container className='mb-5 mt-2'>
                <h1 className='text-center mb-2'>Regular Bookings</h1>
                <TutorFilterMenu
                  filterVenue={filterVenue}
                  filterDay={filterDay}
                  filterLessonType={filterLessonType}
                  filterAvailableClasses={filterAvailableClasses}
                  Venues={Venues}
                  LessonTypes={LessonTypes}
                  setFilterVenue={setFilterVenue}
                  setFilterDay={setFilterDay}
                  setFilterLessonType={setFilterLessonType}
                  setFilterAvailableClasses={setFilterAvailableClasses}
                />
                {filteredClasses.length !== 0 ? (
                  <>
                    {" "}
                    {Venues.map((Venue) => (
                      <VenueBlock key={Venue} filteredClasses={filteredClasses} Venue={Venue} />
                    ))}
                  </>
                ) : (
                  <Row>
                    <Col sm='12' className='shadow mt-4 p-3 border text-center'>
                      <div>
                        <h3>No classes returned. Try filtering again.</h3>
                      </div>
                    </Col>
                  </Row>
                )}
              </Container>
            ) : (
              <LoadingSpinner />
            )}
          </div>
        ) : (
          <Navigate to='/tutor/' />
        )}
      </FadeIn>
    </div>
  );
};

const VenueBlock = (props) => {
  //Sort the days by number.
  const daySorter = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
  };

  const filteredClasses = props.filteredClasses
    .sort((a, b) => {
      return a.StartTime.localeCompare(b.StartTime);
    })
    .sort(function sortByDay(a, b) {
      let day1 = a.Day;
      let day2 = b.Day;
      return daySorter[day1] - daySorter[day2];
    });

  // Filter to venue only classes
  const venueClasses = filteredClasses.filter((t) => {
    return t.Venue.VenueName === props.Venue;
  });

  if (venueClasses.length > 0) {
    return (
      <>
        <Row>
          <Col>
            <h1 className='mt-4 text-center'>{props.Venue}</h1>
          </Col>
        </Row>
        <Table
          striped
          bordered
          hover
          responsive
          size='sm'
          className='text-center shadow one_line_table'
        >
          <thead>
            <tr>
              {/* desktop */}
              <th className='d-none d-md-table-cell'>Day</th>
              <th className='d-none d-md-table-cell'>Time</th>
              <th className='d-none d-md-table-cell'>Type</th>
              <th className='d-none d-md-table-cell'>Waiting</th>
              <th className='d-none d-md-table-cell'>Info</th>
              <th className='d-none d-md-table-cell'>Current Register</th>
              {/* desktop */}
              {/* mobile */}
              <th className='d-table-cell d-md-none'>Details</th>
              <th className='d-table-cell d-md-none'>Type</th>
              <th className='d-table-cell d-md-none'>View/Register</th>
              {/* mobile */}
            </tr>
          </thead>
          <tbody>
            {venueClasses.map((ClassSession) => (
              <tr key={ClassSession._id}>
                {/* desktop */}
                <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                  {ClassSession.Day}
                </td>
                <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                  <strong>
                    {ClassSession.StartTime} - {ClassSession.FinishTime}
                  </strong>
                </td>
                <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                  <strong>{ClassSession.LessonType}</strong>
                  <br />
                  {ClassSession.isHiddenFromSchedule === "public" ? <MdVisibility /> : <MdVisibilityOff />}
                </td>
                <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                  {ClassSession.WaitingListSize}
                </td>
                <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                  {" "}
                  <Button
                    as={Link}
                    to={`/tutor/classes/${ClassSession._id}`}
                    size='sm'
                    className="w-100"
                    variant='info'
                  >
                    Info
                  </Button>
                </td>
                <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                  <Button
                    to={`/tutor/registers/${ClassSession.Current_Register}`}
                    as={Link}
                    size='sm'
                    className="w-100"
                    variant='secondary'
                  >
                    Register{" "}
                    <strong>
                      ({ClassSession.Subscribers_Number} / {ClassSession.MaxLearners})
                    </strong>
                  </Button>
                </td>
                {/* desktop */}
                {/* mobile */}
                <td className='align-self-center align-middle d-table-cell d-md-none view-table'>
                  {ClassSession.Day}
                  <br />
                  <strong>
                    {ClassSession.StartTime} - {ClassSession.FinishTime}
                  </strong>
                  <br />
                  {ClassSession.WaitingListSize} Waiting
                </td>
                <td className='align-self-center align-middle d-table-cell d-md-none view-table'>
                  <strong>{ClassSession.LessonType}</strong>
                </td>
                <td className='align-self-center align-middle d-table-cell d-md-none view-table'>
                  <Button
                    variant='info'
                    size='sm'
                    as={Link}
                    className="w-100"
                    to={`/tutor/classes/${ClassSession._id}`}
                  >
                    Info
                  </Button>
                  <br />
                  <Button
                    variant='success'
                    size='sm'
                    as={Link}
                    to={`/tutor/registers/${ClassSession.Current_Register}`}
                    className='mt-1 w-100'
                  >
                    Register{" "}
                    <strong>
                      ({ClassSession.Subscribers_Number} / {ClassSession.MaxLearners})
                    </strong>
                  </Button>
                </td>
                {/* mobile */}
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );
  } else {
    return null;
  }
};

const TutorFilterMenu = (props) => {
  // Reset all the filters
  const onResetFilter = () => {
    props.setFilterDay("");
    props.setFilterAvailableClasses("");
    props.setFilterLessonType("");
    props.setFilterVenue("");
    sessionStorage.removeItem("filterVenue");
    sessionStorage.removeItem("filterDay");
    sessionStorage.removeItem("filterLessonType");
    return sessionStorage.removeItem("filterAvailableClasses");
  };
  // Filter by Venue
  const onVenueChange = (e) => {
    props.setFilterVenue(e.target.value);
    return sessionStorage.setItem("filterVenue", JSON.stringify(e.target.value));
  };
  //Filter by Day
  const onDayChange = (e) => {
    props.setFilterDay(e.target.value);
    return sessionStorage.setItem("filterDay", JSON.stringify(e.target.value));
  };
  // Filter by LessonType
  const onLessonTypeChange = (e) => {
    props.setFilterLessonType(e.target.value);
    return sessionStorage.setItem("filterLessonType", JSON.stringify(e.target.value));
  };
  // Filter by Available
  const onFilterAvailableClasses = () => {
    let newState;
    if (props.filterAvailableClasses === "true") {
      newState = "false";
    } else {
      newState = "true";
    }
    props.setFilterAvailableClasses(newState);
    return sessionStorage.setItem("filterAvailableClasses", JSON.stringify(newState));
  };

  return (
    <>
      <Row className='shadow-element pb-4 prominentBox'>
        <Col sm='6' lg='4'>
          <Form className='Venue mt-3'>
            <Form.Label>Venue</Form.Label>
            <Form.Control
              as='select'
              value={props.filterVenue}
              onChange={onVenueChange}
              custom
              className='border'
            >
              <option value=''>Any Venue</option>
              {props.Venues.map((Venue) => (
                <option key={Venue} value={Venue}>
                  {Venue}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col sm='6' lg='4'>
          <Form className='Venue mt-3'>
            <Form.Label>Day</Form.Label>
            <Form.Control
              as='select'
              value={props.filterDay}
              onChange={onDayChange}
              custom
              className='border'
            >
              <option value=''>Any Day</option>
              <option value='Monday'>Monday</option>
              <option value='Tuesday'>Tuesday</option>
              <option value='Wednesday'>Wednesday</option>
              <option value='Thursday'>Thursday</option>
              <option value='Friday'>Friday</option>
              <option value='Saturday'>Saturday</option>
              <option value='Sunday'>Sunday</option>
            </Form.Control>
          </Form>
        </Col>
        <Col sm='12' lg='4'>
          <Form className='Venue mt-3'>
            <Form.Label>Type</Form.Label>
            <Form.Control
              as='select'
              value={props.filterLessonType}
              onChange={onLessonTypeChange}
              custom
              className='border'
            >
              <option value=''>Any Type</option>
              {props.LessonTypes.map((LessonType) => (
                <option key={LessonType} value={LessonType}>
                  {LessonType}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col sm='12' lg='12' className='d-inline-flex justify-content-center align-items-center'>
          <Form className='Venue mt-3'>
            <Form.Check
              type='checkbox'
              label='Spaces Available'
              onChange={onFilterAvailableClasses}
              checked={props.filterAvailableClasses === "true"}
            />
          </Form>
        </Col>
        <Col sm='12' lg='12' className='d-inline-flex justify-content-center align-items-center'>
          <Button
            variant='secondary'
            size='sm'
            type='button'
            className='mt-2'
            onClick={onResetFilter}
          >
            clear
          </Button>
        </Col>
      </Row>
    </>
  );
};

//export the component
export default OverviewPage;
